<template>
  <div>
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <div class="title-h3">{{targetTableTitle}}</div>
        <div class="setting-addel mr-l15">
          <el-button size="mini" @click="onSaveSecurityRule"><i class="fas fa-plus"></i></el-button>
          <el-button size="mini" @click="onDeleteSecurityRule" :disabled="selectedRowArray.length === 0"><i class="fas fa-minus"></i></el-button>
        </div>
      </div>
      <div>
        <w-header-search-button @click="setSearchToolVisible"></w-header-search-button>
      </div>
    </el-row>
    <el-table-wrapper :column-default="columnDefault" @condition-change="onChangeTable" :total="total" remote row-class-name="c-dblclick"
      @row-dblclick="onDblClickRow" @selection-change="changeHandleSelection" style="width:100%;"
      ref="settingList" slot="body" :data="tableData" :columns="tableColumn" :pagination="true" :show-custom-header="true" :show-search-tool="showSearchTool">
    </el-table-wrapper>
    <w-add-security-policy-sliding-popup @load-data="loadData" :target-data="targetData" slot="body" ref="securityPolicySliding"></w-add-security-policy-sliding-popup>
  </div>
</template>

<script>
import msgUtil from '@/utils/message';
import { columnDefault } from '@/constants/table';
import NetdeviceSecurityPolicySettingsAPI from '@/api/settings/netdevice/netdevice-security-policy-settings';
import { EMPTY_TEXT } from '@/utils/string';
import { isNil } from 'lodash';
import WAddSecurityPolicySlidingPopup from '../popup/AddSecurityPolicySlidingPopup';

export default {
  name: 'WSecurityRuleList',
  components: {
    WAddSecurityPolicySlidingPopup,
  },
  props: {
    targetData: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    targetData: {
      immedate: true,
      handler() {
        this.$nextTick(() => {
          if (!isNil(this.$refs.settingList)) {
            this.$refs.settingList.clearFilter();
          }
          this.loadData();
          this.targetTableTitle = `${this.targetData.objCompanyName} 보안 정책 목록`;
        });
      },
    },
  },
  data() {
    return {
      total: null,
      columnDefault,
      targetTableTitle: '보안 정책 목록',
      changeFlag: false,
      showSearchTool: false,
      selectedRowArray: [],
      tableData: [],
      tableColumn: [
        {
          type: 'selection',
        },
        {
          prop: 'policyId',
          label: '정책 ID',
          searchable: true,
          sortable: true,
        },
        {
          prop: 'policyDescr',
          searchable: true,
          label: '정책명',
          sortable: true,
        },
        {
          prop: 'ruleCount',
          label: '룰 (Rule) 수',
          sortable: true,
        },
        {
          prop: 'objIds',
          label: '적용 장비 수',
          sortable: true,
          formatter: this.formatterObjCount,
        },
        {
          prop: 'scheduleFlag',
          label: '스케줄 여부',
          sortable: true,
          formatter: this.scheduleFlagFomatter,
        },
      ],
    };
  },
  methods: {
    loadData() {
      const tableParams = this.$refs.settingList.getParameter();
      const params = {
        objCompanyId: this.targetData.objCompanyId,
        ...tableParams,
      };
      // 선택한 벤더의 정책위반 정보를 조회한다.
      NetdeviceSecurityPolicySettingsAPI.getNetdevicePolicyViolation(params).then((res) => {
        if (res.data.success) {
          this.tableData = res.data.data;
          this.total = res.data.total;
        }
      });
    },
    onChangeTable() {
      this.loadData();
    },
    // 테이블 체크박스 셀렉션 change함수
    changeHandleSelection(selectVal) {
      this.selectedRowArray = selectVal;
    },
    setSearchToolVisible() {
      this.showSearchTool = !this.showSearchTool;
    },
    getEmptyText(row, column, value) {
      if (!isNil(value)) {
        return value;
      }
      return EMPTY_TEXT;
    },
    onDeleteSecurityRule() {
      const action = msgUtil.action.DELETE;
      this.$confirm(...msgUtil.getBasicConfirmData(action)).then(() => {
        const target = '보안 정책';
        NetdeviceSecurityPolicySettingsAPI.deleteNetdevicePolicyViolation(this.selectedRowArray).then((res) => {
          if (res.data.success) {
            this.$message(msgUtil.getResultMsgData(action, target, true));
            this.loadData();
          } else {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          }
        }).catch(() => {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        });
      });
    },
    onSaveSecurityRule() {
      this.$refs.securityPolicySliding.open();
    },
    scheduleFlagFomatter(row, column, value) {
      if (value === 'Y') {
        return '등록';
      }
      return EMPTY_TEXT;
    },
    // 컬럼 더블 클릭 이벤트 - 수정 팝업창을 띄운다
    onDblClickRow(row) {
      this.wizardMode = 'update';
      this.$nextTick(() => {
        this.$refs.securityPolicySliding.open(row);
      });
    },
    /**
     * 적용 장비 수 개수를 반환한다.
     * @param  {[type]} row    [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     * @return {[type]}        [description]
     * @author jda
     */
    formatterObjCount(row, column, value) {
      return value.length;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/settings/netdevice/RuleViolationSettings/SecurityRuleSettigns/component/SecurityRuleList.vue